export default __webpack_public_path__ + "79a96288676a9d1d4824b46650288865.svg";